import { useQuery } from 'shared-ui';

import { fetchDodCapabilities } from 'api/dod/dod.v2';
import { DodCapabilities } from 'api/dod/dod.v2.types';
import { QueryKeyEnum } from 'core/global.enum';

/**
 * Conservative fallback used while the probe is in flight or when the endpoint is missing
 * (an older backend answers 404). Prometheus-only controls stay hidden rather than rendering
 * a panel that can never load.
 */
export const DOD_FALLBACK_CAPABILITIES: DodCapabilities = {
  timeseries: false,
  prometheus: false,
  worker: false,
};

export const useDodCapabilities = (): { capabilities: DodCapabilities; isLoading: boolean } => {
  const { data, isLoading } = useQuery([QueryKeyEnum.DOD_CAPABILITIES], fetchDodCapabilities, {
    handleErrorManually: true,
    staleTime: 5 * 60 * 1000,
    retry: false,
  });

  return { capabilities: data ?? DOD_FALLBACK_CAPABILITIES, isLoading };
};
